import { useEffect, useState } from 'react';
import './styles.scss';
import getComputerList from '../API/apiHelper';
import mockComputerList from '../API/mockData';
import Floor from './floor/Floor';

const ComputerList = () => {
    const [computerList, setComputerList] = useState([]);

    const fetchData = async () => {
        try {
            const data = await getComputerList();

            if (Array.isArray(data)) {
                setComputerList(data);
            } else if (process.env.NODE_ENV === 'development') {
                // сервер клуба недоступен — показываем тестовые данные для просмотра схемы
                setComputerList(mockComputerList);
            }
        } catch (error) {
            console.error('Ошибка при получении списка компьютеров:', error);
        }
    };

    useEffect(() => {
        fetchData();

        const interval = setInterval(() => {
            fetchData();
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="mainContainer">
            <div className="welcomeTitle">
                <p className="welcomeTitle-main">Добро пожаловать</p>
                <p className="welcomeTitle-sub">Хорошей игры!</p>
            </div>

            <div className="desktopContainer">
                <Floor psList={computerList} />
            </div>
        </div>
    );
};

export default ComputerList;
